module.exports = __webpack_public_path__ + "media/images/lp_v6_img02-303cf406eeceb8f02b6ac8c68391febc.webp";